import { ElementRef } from '@angular/core';

export default class Utils {
  static forcusAndScrollToElement(certificateNoEl: ElementRef<any>) {
    if (certificateNoEl && certificateNoEl.nativeElement) {
      certificateNoEl.nativeElement.focus();
      // scroll to element -> improve UX
      if (
        !Utils.isElementInViewport(certificateNoEl.nativeElement.parentElement)
      ) {
        if (certificateNoEl.nativeElement.parentElement) {
          // scroll to parent to include the label
          certificateNoEl.nativeElement.parentElement.scrollIntoView();
        } else {
          certificateNoEl.nativeElement.scrollIntoView();
        }
      }
    }
  }
  /**
   * build the error message incase backend return error content
   * @param rs an error obj
   */
  static toErrorMessage(rs: any, defaultMessage: string): string {
    let errorMessage =
      rs.message == null
        ? defaultMessage
        : `${rs.message}
`; // Enter new line
    for (const key in rs.data) {
      if (rs.data.hasOwnProperty(key)) {
        const value = rs.data[key];
        errorMessage += `${value}
`; // Enter new line
      }
    }
    return errorMessage;
  }

  static isElementInViewport(el: any): boolean {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight ||
          document.documentElement.clientHeight) /*or $(window).height() */ &&
      rect.right <=
        (window.innerWidth ||
          document.documentElement.clientWidth) /*or $(window).width() */
    );
  }
}
